import { navigate } from "../router";
import { KindTag } from "./KindTag";

/**
 * Where this thing sits: project › deliverable › task.
 *
 * The hierarchy is the reason deliverables exist, so it is shown rather than
 * left to be remembered from how you happened to arrive — which matters most
 * for someone who did not navigate here at all, but opened a pasted link.
 *
 * The current item is not repeated. The page title says what you are looking
 * at; the trail says what it belongs to.
 */
export function Crumbs({
  projectId,
  projectName,
  deliverableId,
  deliverableName,
}: {
  projectId?: string | null;
  projectName?: string | null;
  deliverableId?: string | null;
  deliverableName?: string | null;
}) {
  const hasProject = Boolean(projectId && projectName);
  const hasDeliverable = Boolean(deliverableId && deliverableName);
  if (!hasProject && !hasDeliverable) return null;

  return (
    <nav className="crumbs">
      {hasProject ? (
        <>
          <KindTag kind="project" size="crumb" />
          <button
            className="linkish proj-name"
            onClick={() => navigate({ kind: "project", id: projectId! })}
          >
            {projectName}
          </button>
        </>
      ) : null}

      {hasProject && hasDeliverable ? <span className="sep">›</span> : null}

      {hasDeliverable ? (
        <>
          <KindTag kind="deliverable" size="crumb" />
          <button
            className="linkish deliv-name"
            onClick={() => navigate({ kind: "deliverable", id: deliverableId! })}
          >
            {deliverableName}
          </button>
        </>
      ) : null}
    </nav>
  );
}
